import { Metric } from '..';
import MetricAttributes from '../MetricAttributes';
import FAR_FUTURE_TIME from './FarFutureTime';
import { Log } from '../../logging/Log';
const Trace = (name, tenantId, options) => {
    const logger = Log(tenantId);
    const startTime = (options === null || options === void 0 ? void 0 : options.startTime) || Date.now();
    let endTime = options === null || options === void 0 ? void 0 : options.endTime;
    const metricAttributes = MetricAttributes();
    let didLog = false;
    function getEndTime() {
        if (!endTime) {
            endTime = Date.now();
        }
        return endTime;
    }
    function getDuration() {
        const duration = getEndTime() - startTime;
        // Check if the duration is invalid
        const numericLimit = 9999999999999.99; // Maximum value for NUMERIC(15,2) required for Redshift import
        if (duration < 0 || duration > numericLimit || Number.isNaN(duration)) {
            logger.error(`Duration is invalid for trace ${name}: ${duration} = ${getEndTime()} - ${startTime}`);
            return -1;
        }
        return duration;
    }
    function toMetric() {
        return Metric(name, tenantId, {
            attributes: metricAttributes.toAttributes(),
        });
    }
    return {
        mergeAttributes(newAttributes) {
            metricAttributes.mergeAttributes(newAttributes);
        },
        log() {
            if (didLog) {
                return;
            }
            if (getDuration() < 0) {
                return;
            }
            if (endTime === FAR_FUTURE_TIME) {
                return;
            }
            metricAttributes.mergeAttributes({ msDuration: getDuration() });
            didLog = true;
            toMetric().put();
        },
        getDuration,
    };
};
export default Trace;
//# sourceMappingURL=Trace.js.map